import axios, { AxiosResponse } from 'axios';
import { authFetch } from '.';
import { ISpecialtyType } from '../models';

const baseUrl = '/api/Admin/SpecialtyType';

export const ISpecialtyTypesAPI = {
  async getAll(): Promise<ISpecialtyType[]> {
    try {
      const response: AxiosResponse<ISpecialtyType[]> = await authFetch.get(baseUrl);

      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },

  async upsert(upsertData: ISpecialtyType[]): Promise<ISpecialtyType[]> {
    try {
      const response: AxiosResponse<ISpecialtyType[]> = await authFetch.put(baseUrl, upsertData);

      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },

  async delete(specialtyTypeId: string|number): Promise<void> {
    try {
      const response = await authFetch.delete(`${baseUrl}/${specialtyTypeId}`);

      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },
};
